import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";
import { Instagram, MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_HREF, PHONE_HREF, WHATSAPP_LOCAL } from "./WhatsAppFab";

const Footer = () => {
  const { t, routes } = useI18n();
  const ig = "https://instagram.com/safemat";

  return (
    <footer className="bg-slate-950 text-slate-300 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-4">
        <Link to={routes.home} className="flex items-center group" data-testid="logo-link">
          <img
            src="/safemat-logo.png"
            alt="SAFEMAT"
            className="h-14 w-auto -my-2 transition-transform group-hover:scale-105"
          />
        </Link>
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed text-sm">{t.footer.tagline}</p>
          <div className="flex gap-2 mt-6">
            <a href={ig} target="_blank" rel="noreferrer" className="border border-slate-800 hover:border-[#016C36] hover:text-[#016C36] p-2.5 rounded-sm transition-colors" data-testid="footer-instagram">
              <Instagram size={16} />
            </a>
            <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="border border-slate-800 hover:border-[#25D366] hover:text-[#25D366] p-2.5 rounded-sm transition-colors" data-testid="footer-whatsapp">
              <MessageCircle size={16} />
            </a>
            <a href={PHONE_HREF} className="border border-slate-800 hover:border-[#016C36] hover:text-[#016C36] p-2.5 rounded-sm transition-colors" data-testid="footer-phone">
              <Phone size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="eyebrow text-slate-500 mb-4">{t.footer.links}</p>
          <ul className="space-y-2 text-sm">
            <li><Link to={routes.home} className="hover:text-white transition-colors">{t.nav.home}</Link></li>
            <li><Link to={routes.desinfection} className="hover:text-white transition-colors">{t.nav.desinfection}</Link></li>
            <li><Link to={routes.pourQui} className="hover:text-white transition-colors">{t.nav.pourQui}</Link></li>
            <li><Link to={routes.contact} className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
            <li><Link to={routes.quote} className="hover:text-white transition-colors">{t.nav.cta}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="eyebrow text-slate-500 mb-4">{t.footer.contact}</p>
          <ul className="space-y-2 text-sm">
            <li><a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="hover:text-white transition-colors">WhatsApp · {WHATSAPP_LOCAL}</a></li>
            <li><a href={PHONE_HREF} className="hover:text-white transition-colors">Tél · {WHATSAPP_LOCAL}</a></li>
            <li className="text-slate-500 pt-1">Suisse romande &amp; alémanique</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 px-5 lg:px-8 max-w-7xl mx-auto flex flex-col sm:flex-row sm:justify-between gap-2 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} SAFEMAT — {t.footer.rights}</span>
        {/* Legal pages temporarily hidden — re-enable when generated.
        <div className="flex gap-4">
          <Link to="/fr/mentions-legales" className="hover:text-white">{t.footer.legalNotice}</Link>
          <Link to="/fr/confidentialite" className="hover:text-white">{t.footer.privacy}</Link>
          <Link to="/fr/cgv" className="hover:text-white">{t.footer.terms}</Link>
        </div>
        */}
      </div>
    </footer>
  );
};

export default Footer;
